import React, {useContext, useEffect} from 'react';
import Link from 'next/link'
import _ from 'lodash';

import MyComment from './MyComment';
import Editor from './Editor';
import ProfileAvatar from '../common/ProfileAvatar';
import UserContext from '../../context/UserContext';

const CommentList = ({ storyId, authorId, comments, setComments, scrollTo, ...props }) => {
    const {loggedInUser} = useContext(UserContext);

    useEffect(() => {
        if(scrollTo) {
            var x = document.getElementById('comment-' + scrollTo)
            if(x)
                x.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                });
        }
    }, [scrollTo])

    const toggleReplyHiddenByCommentId = (commentId) => {
        var temp = _.cloneDeep(comments)
        for (var i = 0; i < temp.length; i++) { 
            if(temp[i].id === commentId)
                temp[i].replyHidden = !temp[i].replyHidden; 
        } 
        return temp;
    }

    const setToValue = (obj, value) => {
        var i;
        const path = value.path.split('.');

        for (i = 0; i < path.length; i++) {
            if(i===0) {
                obj[path[i]] = obj[path[i]] || {};
                obj = obj[path[i]]
            }
            obj.children = obj.children || {};
            if(i!==0)
                obj = obj.children[path[i]];
        }

        obj.children = obj.children || {};
        obj.children[value.id] = value;
    }

    const convertJsonToJSX = (json) => {
        var component = [];

        // Sort Algo for comments
        var sortable = [];
        for (var comment in json) {
            sortable.push(json[comment]);
        }
        sortable.sort((a, b) => {
            if(a['isNewlySubmitted'] === b['isNewlySubmitted']) {
                if(a['created_at'] > b['created_at'])
                    return -1;
            } else {
                if(a['isNewlySubmitted'])
                    return -1
            }
            return 0;
        });

        for (var key of Object.keys(sortable)) {
            const comment = sortable[key];
            component.push(
                <MyComment 
                    key={comment.id}
                    id={comment.id}
                    scrollTo={scrollTo}
                    author={
                        comment.username ? (
                        <Link href="/profile/[username]" as={'/profile/'+ comment.username}>
                            <a>
                                <span className="text-darkable" style={
                                    authorId === comment.user_account_id ? {
                                        color: '#60B6F5'
                                    } : {}
                                }>
                                    {comment.username}
                                </span>
                            </a>
                        </Link>
                        ) : (
                            <span className="text-darkable">[deleted]</span>
                        )
                    }
                    avatar={
                        comment.username ? (
                            <ProfileAvatar 
                                alt={comment.username}
                                shape="square"
                                size={32}
                                avatarUrl={comment?.profile_picture}
                                redirect={'/profile/' + comment.username}
                            />
                        ) : (
                            <ProfileAvatar 
                                alt="deleted"
                                shape="square"
                                size={32}
                            />
                        )
                    }
                    content={comment.username ? (comment.comment_body) : '[deleted]'}
                    like={comment.likes}
                    dislike={comment.dislikes}
                    createDatetime={comment.created_at}
                    updateDatetime={comment.updated_at}
                    myLikeDislike={comment.like_dislike}
                    myLikeDislikeId={comment.like_dislike_id}
                    myLikeDislikeCreatedAt={comment.like_dislike_created_at}                    
                    replyToHandler={(commentId) => {
                        setComments(toggleReplyHiddenByCommentId(commentId));
                    }}
                    children={
                        <div> 
                            {!comment.replyHidden ? (
                                <Editor
                                    parentId={comment.id.toString()}
                                    storyId={storyId}
                                    path={comment.path + '.'  + comment.id.toString()}
                                    handleSubmitRes={res => {
                                        setComments([
                                            ...toggleReplyHiddenByCommentId(comment.id),
                                            {
                                                ...res, ...{
                                                    username: loggedInUser.username,
                                                    profile_picture: loggedInUser.profile_picture,
                                                    user_account_id: loggedInUser.id,
                                                    isNewlySubmitted: true,
                                                    replyHidden: true,
                                                    like_dislike: null,
                                                    like_dislike_created_at: null,
                                                    like_dislike_id: null,
                                                    likes: null,
                                                    dislikes: null,
                                                }
                                            },
                                        ])
                                    }}
                                    {...props}
                                />
                            ) : null}
                            {comment.children ? convertJsonToJSX(comment.children) : null}
                        </div>
                    }
                    {...props}
                />
            );
        }

        return component;
    }

    const buildCommentTree = () => {
        var tree = {};

        for (var comment of comments) {
            setToValue(tree, comment);
        }

        const componentList = [];
        componentList.push(convertJsonToJSX(tree[storyId]?.children));

        return componentList;
    }

    return (
        buildCommentTree()
    );
}

export default CommentList;